enum RoutesEnum {
  PAGE_PARTNERS = "/partners",
  PAGE_EXPERTS = "/experts",
  PAGE_COURSES = "/courses",
  PAGE_ARTISTS = "/artists",
  PAGE_FINALISTS = "/finalists",
}
export default RoutesEnum;
